export default "__VITE_ASSET__fFaNIf8F__"